module.exports = __webpack_public_path__ + "img/6.2b368242.png";